import { AutoComplete, Button, Image, Input, message, Modal, Tooltip, Upload } from 'antd';
import './index.less';
import { ReactComponent as OpenUseLogSvg } from "./icon/open-use-log.svg";
import { useContext, useEffect, useRef, useState } from 'react';
import { UserFeedback } from '@/declare/interface/feedback/user-feedback';
import { createUserFeedback, deleteUserFeedbacks, getFeedbackFileUrl, getUserFeedbacks, updateUserFeedback } from '@/declare/api/feedback/user-feedback';
import dayjs from 'dayjs';
import TextArea from 'antd/lib/input/TextArea';
import { ReactComponent as FaSendSvg } from './icon/fa_send.svg';
import { ReactComponent as FileSvg } from './icon/file.svg';
import classNames from 'classnames';
import { UserFeedbackUploadFileContext } from '@/App';
import UserFeedbackUploadPanel, { UserFeedbackFileUploadParam, UserFeedbacUploadFileLocale } from './upload-panel';
import localStore from '@/store/local-store';
import { SOFTWARE_PROJECT_ID, SOFTWARE_PROJECT_NAME } from '@/store/constant';
import Icon, {
    ExclamationCircleOutlined,
    FolderOutlined,
} from '@ant-design/icons'
import DragModal from '@/baseui/drag-modal/DragModal';
import TnPmModal from '@/baseui/modal';
import ContextMenu from '@/baseui/right-menu/context-menu';
import MenuList from '@/baseui/right-menu/menu-list';
import MenuItem from '@/baseui/right-menu/menu-item';

interface IBtnProps {
    visible: boolean
    changeVisible: (visible: boolean) => void;
}

export const UserFeedbackActiveBtn = (props: IBtnProps) => {

    return <div className='user-feedback-active-btn-container' >
        <Tooltip title="反馈">
            <div className='btn' onClick={() => props.changeVisible(true)}><OpenUseLogSvg /></div>
        </Tooltip>
    </div>
}

interface IProps {
    visible: boolean
    changeVisible: (visible: boolean) => void;
}

const Upload_BUCKET_NAME = "feedback";

interface File {
    fileMd5: string,
    fileSize: number,
    fileSuffix: string,
    filePath: string,
    url: string
}

export default function UserFeedBackPanel(props: IProps) {

    const uploadFileContext = useContext(UserFeedbackUploadFileContext);

    const projectId = SOFTWARE_PROJECT_ID;
    const projectName = SOFTWARE_PROJECT_NAME;

    const [feedbacks, setFeedbacks] = useState<UserFeedback[]>([]);
    const [inputValue, setInputValue] = useState<string>('');
    const [keywordValue, setKeywordValue] = useState<string>('');

    const inputValueRef = useRef<string>();
    const keywordValueRef = useRef<string>();

    const [sendLoading, setSendLoading] = useState(false);

    const [uploadFileList, setUploadFileList] = useState([]);
    const [file, setFile] = useState<File>(null);
    const fileRef = useRef(file);

    // 右键
    const [cmVisible, setCmVisible] = useState(false);
    const [cmFeedbackId, setCmFeedbackId] = useState(0);
    const [cmTop, setCmTop] = useState(0);
    const [cmLeft, setCmLeft] = useState(0);
    const [editFeedBackId, setEditFeedbackId] = useState(null);
    const [keyword, setKeyword] = useState(''); // 关键词
    const [content, setContent] = useState(''); // 内容

    const [keywords, setKeywords] = useState<any[]>([]); // 关键词数组

    useEffect(() => {
        inputValueRef.current = inputValue;
    }, [inputValue])

    useEffect(() => {
        keywordValueRef.current = keywordValue;
    }, [keywordValue])

    useEffect(() => {
        if (!props.visible) return;
        getUserFeedbacks({ projectId: SOFTWARE_PROJECT_ID }).then(res => {
            let feedbacks = res.data || []
            setFeedbacks(feedbacks);
            let keywords = [];
            feedbacks.forEach(item => {
                if (item.keyword && item.keyword?.trim().length > 0) {
                    keywords.push({ value: item.keyword.trim() })
                }
            })
            // 去重
            keywords = keywords.filter((item, index, self) =>
                index === self.findIndex((t) => (
                    t.value === item.value
                ))
            );
            setKeywords(keywords);
            scrollToBottom();
        }).catch(err => {
            message.error("获取反馈失败")
        })

    }, [props.visible])

    useEffect(() => {
        fileRef.current = file;
    }, [file])

    useEffect(() => {
        if (!props.visible) return;
        window.addEventListener('keydown', onKeydown);
        return () => {
            window.removeEventListener('keydown', onKeydown);
        }
    }, [props.visible])

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UserFeedbacUploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    useEffect(() => {
        if (!uploadFileContext.visible) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    const uploadCallbackFn = (uploadFile: UserFeedbackFileUploadParam) => {
        return new Promise(resolve => {
            const file: File = {} as File;
            file.fileMd5 = uploadFile.md5;
            file.fileSize = uploadFile.fileSize;
            file.fileSuffix = uploadFile.suffix;
            file.filePath = uploadFile.filePath;

            getFeedbackFileUrl(file.filePath, Upload_BUCKET_NAME).then(res => {
                if (res.status === 200) {
                    file.url = res.data;
                    setFile({ ...file });
                }
            }).finally(() => {
                resolve(true);
            })
        })
    }

    const onKeydown = (e) => {
        let keywordValue = keywordValueRef.current
        let inputValue = inputValueRef.current
        if (e.ctrlKey && e.key === 'Enter') {
            if (inputValue.length <= 0 || keywordValue.length <= 0) {
                message.error('请输入反馈内容和关键词');
                return;
            };
            sendFeekback();
        } else if (e.ctrlKey && e.key === 'v') {
            navigator.clipboard.read()
                .then(items => {
                    items.forEach(item => {
                        if (item.types.includes('image/png')) {
                            item.getType('image/png').then(blob => {
                                const file = new File([blob], '反馈图片.png', { type: blob.type });
                                beforeUpload(file, [file]);
                            }).catch(err => {
                                message.error("粘贴图片失败");
                            });
                        }
                    });
                }).catch(err => {
                    // message.error("获取剪贴板内容失败：" + err)
                });
        }
    }

    const sendFeekback = () => {
        const name = localStore.name || '未知'
        if (!name) return;
        let keywordValue = keywordValueRef.current
        let inputValue = inputValueRef.current
        if (keywordValue === '') {
            message.warning('请输入主题')
            return;
        }
        if (inputValue === '') {
            message.warning('请输入内容')
            return;
        }
        let dataIn: UserFeedback = {
            userName: name,
            content: inputValue,
            keyword: keywordValue,
            projectId: projectId,
            projectName: projectName,
        } as UserFeedback
        // ctrl enter是事件绑定，拿不到新的文件
        if (fileRef.current != null) {
            dataIn = {
                ...dataIn,
                ...fileRef.current
            }
        }
        setSendLoading(true)
        createUserFeedback(dataIn).then(res => {
            if (res.status === 200 && res.data) {
                // message.success('发送成功');
                dataIn.id = res.data;
                dataIn.gmtCreate = dayjs().valueOf();
                dataIn.gmtUpdate = dayjs().valueOf();
                setFeedbacks([...feedbacks, dataIn])
                scrollToBottom();
            }
        }).catch(() => {
            message.error('发送失败');
        }).finally(() => {
            setInputValue('');
            setKeywordValue('');
            setFile(null);
            setSendLoading(false);
        })
    }

    const scrollToBottom = () => {
        setTimeout(() => {
            const list = document.getElementById('feedback-list');
            if (list === null || list.children.length === 0) return;
            list.children[list.children.length - 1].scrollIntoView({ behavior: 'smooth', block: 'end' });
        }, 200);
    }

    const beforeUpload = (file, fileList) => {
        if (!file.type.includes('image')) {
            message.error('请上传图片');
            return false;
        }
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    // 右键
    const onContextMenu = (e, feedbackId: number) => {
        e.preventDefault();
        if (cmFeedbackId === feedbackId || editFeedBackId === feedbackId) return;
        setEditFeedbackId(null);
        const name = localStore.name || '未知'
        const feed = feedbacks.find(f => f.id === feedbackId);
        if (!feed || feed.userName !== name || (feed.userName !== name && feed.userName === "未知")) return;
        setCmFeedbackId(feedbackId);
        setCmVisible(true);
        setCmTop(e.clientY);
        setCmLeft(e.clientX);
    }

    // 激活编辑
    const activeEditFeedback = () => {
        setCmVisible(false);
        const feed = feedbacks.find(f => f.id === cmFeedbackId);
        if (!feed) return;
        setEditFeedbackId(cmFeedbackId);
        setCmFeedbackId(null);
        setKeyword(feed.keyword);
        setContent(feed.content);
    }

    // 激活删除
    const activeDeleteFeedback = () => {
        setCmFeedbackId(null);
        setCmVisible(false);
        Modal.confirm({
            title: '删除',
            icon: <ExclamationCircleOutlined style={{ color: '#FF4D4F' }} />,
            content: '是否确认删除？',
            okText: '确认',
            cancelText: '取消',
            wrapClassName: 'project-activity-modal',
            okButtonProps: {
                className: 'ok-btn'
            },
            cancelButtonProps: {
                className: 'cancel-btn'
            },
            onOk: () => {
                deleteUserFeedbacks([cmFeedbackId]).then(res => {
                    const idx = feedbacks.findIndex(f => f.id === cmFeedbackId);
                    feedbacks.splice(idx, 1);
                    setFeedbacks([...feedbacks]);
                    // message.success('删除成功');
                }).catch(err => {
                    message.error('删除失败');
                }).finally(() => {
                    Modal.destroyAll();
                })
            }
        });
    }

    // 保存
    const onSave = () => {
        const feed = feedbacks.find(f => f.id === editFeedBackId);
        if (!feed) {
            return;
        }
        if (keyword == null || keyword === '') {
            message.warning("关键词不能为空");
            return;
        }
        if (content == null || content === '') {
            message.warning("内容不能为空");
            return;
        }
        setEditFeedbackId(null);
        feed.keyword = keyword;
        feed.content = content;
        setKeyword('');
        setContent('');
        updateUserFeedback(editFeedBackId, feed).then(res => {
            // message.success("修改成功");
            setFeedbacks([...feedbacks]);
        }).catch(err => {
            message.error("修改失败");
        })
    }

    const onCancel = () => {
        setEditFeedbackId(null);
        setKeyword('');
        setContent('');
    }

    return (
        <>
            <Modal
                title='记录'
                open={props.visible}
                mask
                wrapClassName='user-feedback-modal-container'
                width={860}
                footer={null}
                onCancel={() => props.changeVisible(false)}
            >
                <div className='feedback-box'>
                    <div id="feedback-list" className='feedback-list'>
                        {feedbacks.map(feedback => {
                            return <div id={feedback.id.toString()} className='feedback-item' key={feedback.id}>
                                <div className='top'>
                                    <div className='title'>
                                        <div className={classNames({
                                            'keyword': true,
                                            'edit': editFeedBackId === feedback.id
                                        })}>
                                            {editFeedBackId !== feedback.id && feedback?.keyword}
                                            {editFeedBackId === feedback.id && <Input value={keyword}
                                                onChange={(e) => setKeyword(e.target.value)} />}
                                        </div>
                                        <div className='username'>{feedback?.userName}</div>
                                        <div className='time'>{dayjs(feedback?.gmtCreate).format('YYYY/MM/DD HH:mm')}</div>
                                    </div>
                                    {feedback.id === editFeedBackId &&
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <Button type='primary' size='small' onClick={onSave}>保存</Button>
                                            <Button size='small' onClick={onCancel}>取消</Button>
                                        </div>
                                    }
                                </div>
                                <div className='content' onContextMenu={(e) => onContextMenu(e, feedback.id)}>
                                    {editFeedBackId !== feedback.id && feedback?.content}
                                    {editFeedBackId === feedback.id && <Input value={content}
                                        onChange={(e) => setContent(e.target.value)} />}</div>
                                {feedback?.fileMd5 && feedback?.url && <div className='img'>
                                    <Image src={feedback?.url} />
                                </div>}
                            </div>
                        })}
                    </div>
                    <div className='feedback-input'>
                        <TextArea
                            readOnly={sendLoading}
                            className='content-input'
                            placeholder='请输入反馈内容 Ctrl+Enter可发送 Ctrl+V上传粘贴板图片(仅可保留一张)'
                            autoSize={{ minRows: 4, maxRows: 4 }}
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)} />
                        <div className='ope-area'>
                            <AutoComplete
                                className='keyword-input'
                                placeholder='功能'
                                maxLength={10}
                                options={keywords.filter(item => item.value.match(new RegExp(keywordValue, 'i')))}
                                value={keywordValue}
                                onChange={(value) => setKeywordValue(value)} />
                            {/* <Input
                                readOnly={sendLoading}
                                className='keyword-input'
                                placeholder='反馈关键词'
                                maxLength={10}
                                value={keywordValue}
                                onChange={(e) => setKeywordValue(e.target.value)} /> */}
                            <span className='fill-remaining-space'></span>
                            <Upload showUploadList={false} beforeUpload={beforeUpload} className="file-upload-wrapper">
                                <FileSvg className='file-upload-icon' />
                            </Upload>
                            <FaSendSvg onClick={() => {
                                if (inputValue.length <= 0 || keywordValue.length <= 0) {
                                    message.error('请输入反馈内容和关键词');
                                    return;
                                };
                                sendFeekback();
                            }} className={classNames({
                                'send-btn': true,
                                'disabled': inputValue.length <= 0 || sendLoading
                            })} />

                        </div>
                    </div>
                </div>
                <UserFeedbackUploadPanel />
            </Modal>
            <ContextMenu
                visible={cmVisible}
                left={cmLeft}
                top={cmTop}
                width={140}
                onCancel={() => {
                    setCmVisible(false);
                }}
                wrapperClassname='feedback-cm-container'
            >
                <MenuList>
                    <MenuItem onClick={activeEditFeedback}>编辑</MenuItem>
                    <MenuItem onClick={activeDeleteFeedback}>删除</MenuItem>
                </MenuList>
            </ContextMenu>
        </>
    )
    //         <div id="feedback-list" className='feedback-list'>
    //             {feedbacks.map(feedback => {
    //                 return <div id={feedback.id.toString()} className='feedback-item' key={feedback.id}>
    //                     <div className='top'>
    //                         <div className='title'>
    //                             <div className='keyword'>{feedback?.keyword}</div>
    //                             <div className='username'>{feedback?.userName}</div>
    //                             <div className='time'>{dayjs(feedback?.gmtCreate).format('YYYY/MM/DD HH:mm')}</div>
    //                         </div>
    //                     </div>
    //                     <div className='content'>{feedback?.content}</div>
    //                     {feedback?.fileMd5 && feedback?.url && <div className='img'>
    //                         <Image src={feedback?.url} />
    //                     </div>}
    //                 </div>
    //             })}
    //         </div>
    //         <div className='feedback-input'>
    //             <TextArea
    //                 readOnly={sendLoading}
    //                 className='content-input'
    //                 placeholder='请输入反馈内容 Ctrl+Enter可发送 Ctrl+V上传粘贴板图片(仅可保留一张)'
    //                 autoSize={{ minRows: 4, maxRows: 4 }}
    //                 value={inputValue}
    //                 onChange={(e) => setInputValue(e.target.value)} />
    //             <div className='ope-area'>
    //                 <Input
    //                     readOnly={sendLoading}
    //                     className='keyword-input'
    //                     placeholder='反馈关键词'
    //                     maxLength={10}
    //                     value={keywordValue}
    //                     onChange={(e) => setKeywordValue(e.target.value)} />
    //                 <span className='fill-remaining-space'></span>
    //                 <Upload showUploadList={false} beforeUpload={beforeUpload} className="file-upload-wrapper">
    //                     <FileSvg className='file-upload-icon' />
    //                 </Upload>
    //                 <FaSendSvg onClick={() => {
    //                     if (inputValue.length <= 0 || keywordValue.length <= 0) {
    //                         message.error('请输入反馈内容和关键词');
    //                         return;
    //                     };
    //                     sendFeekback();
    //                 }} className={classNames({
    //                     'send-btn': true,
    //                     'disabled': inputValue.length <= 0 || sendLoading
    //                 })} title='发送' />

    //             </div>
    //         </div>
    //     </div>

    //     <UserFeedbackUploadPanel />
    // </Modal>
}